import { gql } from 'graphql-request';

export const GET_LINK_FOR_AUTHORITY = gql`
  query GetLinkForAuthority($poaId: ID!, $inviteId: ID!) {
    corePOA {
      getLinkForAuthority(poaId: $poaId, inviteId: $inviteId)
    }
  }
`;
